module.exports = __webpack_public_path__ + "static/media/sword-common.4f69c6b0.png";